export const LOAD_BUY_RECEIPT = "LOAD_BUY_RECEIPT";
export const FILL_BUY_RECEIPT_INFO = "FILL_BUY_RECEIPT_INFO";
export const CLEAR_RECEIPT_BUY = "CLEAR_RECEIPT_BUY";
export const FIND_TRACKING_DETAILS = "FIND_TRACKING_DETAILS";
export const RESET = "BUY_RECEIPT_RESET";
export const RESET_EXPIRE = "BUY_RECEIPT_RESET_EXPIRE";
